const Pay = () => import('@/views/Pay')

export default [
  {
    path: '/pay',
    component: Pay,
    meta: { requireAuth: true }
  }
]
